import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BookingCardComponent } from '../../booking-card/booking-card.component';
import { AuthService } from '../../../services/Auth/auth.service';

@Component({
    selector: 'app-previous',
    imports: [
        CommonModule,
        BookingCardComponent
    ],
    templateUrl: './previous.component.html',
    styleUrl: './previous.component.scss'
})
export class PreviousComponent {

    constructor(
        public authService: AuthService
    ) {

    }
}
